export default __webpack_public_path__ + "5eb3a8a09f51024f48bab1468385cc6d.png";